(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my_map_section"] && !Shopify.designMode) return;
  try {
    

$(function() {
    $("svg a").click(function(){
        if(String($(this).attr("xlink:href")).charAt(0) == "#"){
        //    window.location.href = $(this).attr("xlink:href");
           
        }
    });



});
function select_t(){

      const select_top_message = "地域をお選びいただけます";
      const chiiki_area = {
          "hokkaido":[{"n":"北海道","s":"hokkaido"}],
          "tohoku":[{"n":"青森","s":"aomori"},{"n":"秋田","s":"akita"},{"n":"岩手","s":"iwate"},{"n":"福島","s":"fukushima"},{"n":"山形","s":"yamagata"},{"n":"宮城","s":"miyagi"}],
          "kanto":[{"n":"東京","s":"tokyo"},{"n":"神奈川","s":"kanagawa"},{"n":"千葉","s":"chiba"},{"n":"埼玉","s":"saitama"},{"n":"群馬","s":"gunma"},{"n":"茨城","s":"ibaraki"},{"n":"栃木","s":"tochigi"}],
          "cyubu":[{"n":"新潟","s":"nigata"},{"n":"富山","s":"toyama"},{"n":"石川","s":"ishikawa"},{"n":"福井","s":"fukui"},{"n":"山梨","s":"yamanashi"},{"n":"長野","s":"nagano"},{"n":"岐阜","s":"gifu"},{"n":"静岡","s":"shizuoka"},{"n":"愛知","s":"aichi"}],
          "kinki":[{"n":"三重","s":"mie"},{"n":"滋賀","s":"shiga"},{"n":"京都","s":"kyoto"},{"n":"大阪","s":"osaka"},{"n":"兵庫","s":"hyogo"},{"n":"奈良","s":"nara"},{"n":"和歌山","s":"wakayama"}],
          "cyugoku":[{"n":"鳥取","s":"tottori"},{"n":"島根","s":"shimane"},{"n":"岡山","s":"okayama"},{"n":"広島","s":"hiroshima"},{"n":"山口","s":"yamaguchi"}],
          "shikoku":[{"n":"徳島","s":"tokushima"},{"n":"香川","s":"kagawa"},{"n":"愛媛","s":"ehime"},{"n":"高知","s":"kouchi"}],
          "kyusyu":[{"n":"福岡","s":"fukuoka"},{"n":"長崎","s":"nagasaki"},{"n":"佐賀","s":"saga"},{"n":"熊本","s":"kumamoto"},{"n":"宮崎","s":"miyazaki"},{"n":"鹿児島","s":"kagoshima"},{"n":"大分","s":"oita"}],
          "okinawa":[{"n":"沖縄","s":"okinawa"}]
      };

      const kaigai_area ={
        "asia":[{"n":"台湾","s":"taiwan"}]
      };

    

      function todofuken_list(area){
        let s = [];
        for(i in area){
          for(k in area[i]){
            s.push(area[i][k]);
          }
        }
        return s;
      };

      const todo = todofuken_list(chiiki_area);
      const oversea = todofuken_list(kaigai_area);
      let select_start = "<select name='todo_select'>";
      let option_start = "<option selected>" + select_top_message + "</option>";
      let select_option = "";
      let select_oversea_option = "";

      let opt_group_jp = "<optgroup label='日本'>";
      let opt_group_over = "<optgroup label='海外'>";
      let end_opt_group = "</optgroup>";
      for(i in todo){
        select_option += "<option value='" + todo[i]["s"] + "'>" + todo[i]["n"] + "</option>";
      }
      for(i in oversea){
        select_oversea_option += "<option value='" + oversea[i]["s"] + "'>" + oversea[i]["n"] + "</option>";
      }
      let select_end = "</select>";
      $("#select_area").append(select_start + option_start + opt_group_jp + select_option + end_opt_group + opt_group_over + select_oversea_option + end_opt_group + select_end);


};
function my_shop_info(){
  const shop_name = "MATIN et ÉTOILE";
  const shiten_name = "TOKYO";
  const shop_ad = "東京都目黒区上目黒1-19-1 1F";
  const shop_tel = "03-6303-0037";
  const shop_time = "11:00 - 19:00";
  const open_day = "Tue 火曜日";

  const shop_start = "<div class='class_fix cyoku'>";
  const shop_end = "</div>";
  const shop_pre = "<div class='shop_info_inner'>";
  const shop_fix = "<div class='myshop_flex'>";
  const shop1 = "<div class='shop_title'>" + shop_name +"</div>";
  const shop2 = "<div class='shiten_title'>" + shiten_name + "</div>";
  const shop3 = "<div class='shop_address'>" + shop_ad + "</div>";
  const shop4 = "<div class='shop_tel'><a href='${shop_tel}'>" + shop_tel + "</a></div>";
  const shop_open = "<div class='shop_open_time'> " + shop_time + " </div>";
  const shop_open_day = "<div class='shop_open_day'>" + open_day + "</div>";
  const shop_flex =  "<div class='shop_flex'>";
  const shop5 = "<div class='shop_img'><img src='https://cdn.shopify.com/s/files/1/0521/9057/6801/files/matinetetoile.jpg?v=1642773642'></div>";
  const shop6 = "<div class='my_maps'>";
  const shop_map = "<iframe src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3243.2238308600245!2d139.70982651521595!3d35.6222081408143!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188b575d091c09%3A0x64e3944501b80417!2zTUFUSU4gZXQgRVRPSUxFICjjg57jgr_jg7Mg44KoIOOCqOODiOOCouODqyk!5e0!3m2!1sja!2sjp!4v1645433152605!5m2!1sja!2sjp' width='100%' height='300' style='border:0;' allowfullscreen='' loading='lazy'></iframe>";
  let shops = shop_start + shop_pre + shop_fix + shop1  + shop2 + shop3 + shop4 + shop_open + shop_open_day + shop_end + shop_flex + shop5 + shop6 + shop_map + shop_end + shop_end + shop_end + shop_end;
  $("#shop_info").append(shops);
}
$(document).ready(function () {

select_t();
$('[name=todo_select').change(function(){
  let values = $(this).val();
  replace_ta(values);
});

  const div_shop = "#shop_info";
  const list_type = {"shop":"shop_info","product":"products"};
  const item_type ={"body":{"type":"body"},"hair":{"type":"hair"},"skin":{"type":"skin"},"hand":{"type":"hand"},"fragrance":{"type":"difu"}};

  const img_body_src = "https://cdn.shopify.com/s/files/1/0521/9057/6801/files/pict_body.png?v=1645086184";
  const img_hair_src = "https://cdn.shopify.com/s/files/1/0521/9057/6801/files/pict_hair.png?v=1645086184";
  const img_hand_src = "https://cdn.shopify.com/s/files/1/0521/9057/6801/files/pict_hand.png?v=1645086184";
  const img_skin_src = "https://cdn.shopify.com/s/files/1/0521/9057/6801/files/pict_skin.png?v=1645060270";
  const img_fregrance_src = "https://cdn.shopify.com/s/files/1/0521/9057/6801/files/pict_fra.png?v=1645086184";
  
window.onload = function(){
if(location.hash != "" ){
    const tops = $("#shop_info").offset().top;
    $("html").animate({scrollTop: tops});
}
}
$('.one').on('click',function(){
    let places_todofuken = $(this).data('todofuken'); 
    replace_ta(places_todofuken);
  });
$('chiho').on('click',function(){
     let place_chiiki = $(this).data('chiiki');
     replace_ta(place_chiiki);
});
function replace_ta(target){
    let path_url = location.protocol + "//" + location.hostname + location.pathname + location.search + "#" + target;
    window.location.href = path_url;
    window.location.reload(); 
}

  let locations = location.hash;
  let place_todofuken = locations.slice(1);
  let area_todofuken = list.filter(function(value,index, array){
    for(let i in value){
      if( value[i][0].publish === 1){
        return value[i][0].todofuken ==  place_todofuken ;
      }
    }
  });
 
  //let area_type = list;
  let  area_type = area_todofuken;
  let pict = new Object();
 
  if(place_todofuken == "tokyo"){
         my_shop_info();
  }
  if(area_type ){
      for(let i  in area_type){
       let arr = area_type[i];
       let arr_products = arr[list_type["product"]][0];
       let arr_shops = arr[list_type["shop"]][0];
       let arr_map = arr[list_type["map"]];
       
       let keys = Object.keys(arr_products);
       for(let k = 0 ; k < keys.length ; k++ ){
            switch(keys[k]){
              case item_type["skin"]["type"]:
              if(arr_products[item_type["skin"]["type"]] === 1 ){
                  pict[item_type["skin"]["type"] + i ] = "<div class='products_fix'><img src='" + img_skin_src + "'></div> ";
                  pict[item_type["skin"]["type"] + i ] = "<div class='products_fix'>skin</div> ";
              }
              break;
              case item_type["body"]["type"]:
              if(arr_products[item_type["body"]["type"]] === 1){
                   pict[item_type["body"]["type"] + i ] = "<div class='products_fix'><img src='" + img_body_src + "'></div> ";   
                   pict[item_type["body"]["type"] + i ] = "<div class='products_fix'>body</div>"
              }
              break;
              case item_type["hand"]["type"]:
              if(arr_products[item_type["hand"]["type"]] === 1){
                  pict[item_type["hand"]["type"] + i ] = "<div class='products_fix'><img src='" + img_hand_src + "'></div> ";
                   pict[item_type["hand"]["type"] + i ] = "<div class='products_fix'>hand</div> ";
              }
              break;
              case item_type["hair"]["type"]:
              if(arr_products[item_type["hair"]["type"]] === 1 ){
                  pict[item_type["hair"]["type"] + i ] ="<div class='products_fix'><img src='" + img_hair_src + "'></div> ";
                   pict[item_type["hair"]["type"] + i ] ="<div class='products_fix'>hair</div> ";
              }
              break; 
              case item_type["fragrance"]["type"]:
              if(arr_products[item_type["fragrance"]["type"]] === 1){
                  pict[item_type["fragrance"]["type"] + i ] =  "<div class='products_fix'><img src='" + img_fregrance_src + "'></div> ";
                  pict[item_type["fragrance"]["type"] + i ] =  "<div class='products_fix'>fragrance</div> ";
              }
              break;
              
              default:
            } 
       }
       let tel_vi = arr_shops.tel ? "<div class='shop_tel'><a href='tel:" + arr_shops.tel + "'>" + arr_shops.tel + "</a></div>" : "";
       let shiten = (arr_shops.shiten ? arr_shops.shiten : "" );
       let kyoutu = "<div class='shop_" + i + " class_fix' >";
       let kyoutu_end = "</div>";
       let shop_sec1 = "<div class='shop_pro_" + i + " shop_info_inner'> ";
       let shop_sec2 = "<div class='shop_title'> <a href='" + arr_shops.homepage + "' target='_blank' rel='noopener noreferrer'>" + arr_shops.shop + " " + shiten + "<img src='https://cdn.shopify.com/s/files/1/0521/9057/6801/files/pict_newtab.png?v=1645345939' width='12px'></a></div>";
       let shop_sec3 = "<div class='shop_address'><a href='" + arr.map + "' target='_blank' rel='noopener noreferrer'>" + arr_shops.address + " <img src='https://cdn.shopify.com/s/files/1/0521/9057/6801/files/pict_newtab.png?v=1645345939' width='12px'></a></div> ";
       let shop_sec4 = tel_vi;
       let pict_wrap = "<div class='pict_wrap'>";
  
       let pict_body =  (pict[item_type["body"]["type"] + i ] ? pict[item_type["body"]["type"] + i ] : "");
       let pict_skin =  (pict[item_type["skin"]["type"] + i ] ? pict[item_type["skin"]["type"] + i ] : "" );
       let pict_hair =  (pict[item_type["hair"]["type"] + i ] ? pict[item_type["hair"]["type"] + i ] : "" );
       let pict_fre =   (pict[item_type["fragrance"]["type"] + i ] ? pict[item_type["fragrance"]["type"] + i ] : "" );
       let pict_hand =  (pict[item_type["hand"]["type"] + i ] ? pict[item_type["hand"]["type"] + i ] : "" );

       
       $(div_shop).append( kyoutu + shop_sec1 + shop_sec2 + shop_sec3 + shop_sec4 + kyoutu_end + pict_wrap + pict_skin + pict_body + pict_hand + pict_hair + pict_fre + kyoutu_end + kyoutu_end);
     
      }
   }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my_popup"] && !Shopify.designMode) return;
  try {
    
window.onload = function () {
	document.getElementById("js_floatingBanner_close").onclick = function () {
	  this.parentNode.classList.add('js_close');
	};
  }
  window.onscroll = function(){
  const wX = window.scrollY;
  const cl = document.getElementById('popup1');
  
  if( cl.classList.contains('js_close') == false){
		  if(wX > 1000){
			  document.getElementById('js_floatingBanner_close').parentNode.classList.add('js_visi');
			  document.getElementById('js_floatingBanner_close').parentNode.classList.remove('js_close2');
		  }else{
			  // document.getElementById('popup1').style.display = 'none';
			  document.getElementById('js_floatingBanner_close').parentNode.classList.remove('js_visi');
			  document.getElementById('js_floatingBanner_close').parentNode.classList.add('js_close2');
		  }
	  }
  }

  } catch(e) { console.error(e); }
})();
})();
